export const removeInstLink = (link: string): string => {
  if (link.includes("https://www.instagram.com/")) {
    const username = link.replace("https://www.instagram.com/", "").split("/")[0];

    return `@${username}`;
  }
  return link;
};
